import dayjs from "dayjs";

export const getDday = (time: string): number => {
    const today = dayjs().startOf("day");
    const target = dayjs(time).startOf("day");
    const diff = target.diff(today, "day");

    return diff;
};
